import config from "./config";

const categories = [
    {
        category: "Jigsaw Puzzle",
        icon: "/img/jigsawpuzzle.jpg",
        // creator: "Yumin Hsu",
        desc: "熟悉漢字形貌。",
        link: `/${config.jigsawpuzzle.directory}`
    },
    {
        category: "7 words",
        icon: "/img/sevenwords.png",
        // creator: "Yumin Hsu",
        desc: "心理學家說，每個人一天都可以輕鬆記得七個單字。",
        link: `/${config.sevenwords.directory}`
    },
    {
        category: "Rearrange Sentnce",
        icon: "/img/rearrangesentence.png",
        // creator: "Yumin Hsu",
        desc: "練習組句能力。",
        demo: "https://ct-data.daoyidh.com/demo/chongzu/",
        link: `/${config.rearrangesentence.directory}`
    },
    {
        category: "Matching Game",
        icon: "/img/matchinggame.png",
        // creator: "Yumin Hsu",
        desc: `熟悉漢字形貌，培養找尋漢字能力。`,
        demo: `https://ct-data.daoyidh.com/demo/matching/`,
        link: `/${config.matchinggame.directory}`
    },
    {
        category: "Rate Dolphin",
        icon: "/img/ratedolphin.jpg",
        // creator: "Yumin Hsu",
        desc: "練習拼音反應能力。",
        demo: "https://ct-data.daoyidh.com/demo/ratedolphin/",
        link: `/${config.ratedolphin.directory}`
    },
    {
        category: "Typing Defense",
        icon: "/img/typingdefense.jpg",
        // creator: "??????",
        desc: "打字練習。",
        link: `/${config.typingdefense.directory}`
    },
    {
        category: "Typing Game",
        icon: "/img/typinggame.jpg",
        // creator: "顏國雄、章薇菲贈陸霞瑛老師",
        desc: "打字練習。",
        demo: "https://ct-data.daoyidh.com/demo/typing/",
        link: `/${config.typinggame.directory}`
    }
];

export default categories;
